import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@shadcn-in-nx/ui/dropdown-menu";
import { Archive, Copy, MoreHorizontal, RotateCcw } from "lucide-react";
import { Button } from "@shadcn-in-nx/ui/button";
import CopyWorkflowModal from "./components/CopyWorkflowModal";

export default function ActionsMenu({ workflow, onArchive, onCopied }) {
    const { t } = useTranslation();
    const [copyOpen, setCopyOpen] = useState(false);
    const isArchived = workflow.status === "ARCHIVED";

    return (
        <>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button variant="ghost" className="h-8 w-8 p-0">
                        <span className="sr-only">{t("workflowIndex.copy.openMenu")}</span>
                        <MoreHorizontal className="h-4 w-4" />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                    {!isArchived && (
                        <>
                            <DropdownMenuItem onClick={() => setCopyOpen(true)}>
                                <Copy className="mr-2 h-4 w-4" />
                                <span>{t("workflowIndex.copy.menuItem")}</span>
                            </DropdownMenuItem>
                            <DropdownMenuSeparator />
                        </>
                    )}
                    <DropdownMenuItem onClick={() => onArchive(workflow)}>
                        {isArchived ? (
                            <>
                                <RotateCcw className="mr-2 h-4 w-4" />
                                <span>{t("workflowIndex.copy.unarchive")}</span>
                            </>
                        ) : (
                            <>
                                <Archive className="mr-2 h-4 w-4" />
                                <span>{t("workflowIndex.copy.archive")}</span>
                            </>
                        )}
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>

            <CopyWorkflowModal
                open={copyOpen}
                onOpenChange={setCopyOpen}
                workflow={workflow}
                onCopied={onCopied}
            />
        </>
    );
}
